import API_END_POINTS from '../../../api/endpoints';
import { dataFetch } from '../../../api/data-fetch';

// initial state
const state = () => ({
  bookmakers: [],
});

// actions
const actions = {
  async fetchBookmakersForStacker({ commit }, brand, fetcher = dataFetch) {
    try {
      const url = `${API_END_POINTS.BOOKMAKERS_FOR_STACKER}&brand=${brand}`;
      const res = await fetcher(url);
      if (res && res.length > 0) {
        const bookmakers = res.sort((a, b) => {
          return a.position - b.position;
        });
        commit('SET_BOOKMAKERS_FOR_STACKERS', { bookmakers });
      }
    } catch (err) {
      console.error(err);
    }
  },
};

// mutations
const mutations = {
  SET_BOOKMAKERS_FOR_STACKERS: (state, { bookmakers }) => {
    state.bookmakers = bookmakers;
  },
};

// getter
const getters = {
  getBookmakersForStacker: state => {
    return state.bookmakers;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
